'use strict';

var _notify = require('linksoft/notify');

var _notify2 = _interopRequireDefault(_notify);

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resx = (0, _localize2.default)("Common");

$(function () {
    CKEDITOR.config.removePlugins = 'wsc,scayt';

    // html5 compatibility: anchor should be able to contain block-level elements
    CKEDITOR.dtd['a']['div'] = 1;
    CKEDITOR.dtd['a']['p'] = 1;
    CKEDITOR.dtd['a']['i'] = 1;
    CKEDITOR.dtd['a']['span'] = 1;
    CKEDITOR.dtd['a']['figure'] = 1;
    CKEDITOR.dtd['a']['h1'] = 1;
    CKEDITOR.dtd['a']['h2'] = 1;
    CKEDITOR.dtd['a']['h3'] = 1;
    CKEDITOR.dtd['a']['h4'] = 1;

    // do not remove empty tags
    $.each(CKEDITOR.dtd.$removeEmpty, function (i, value) {
        CKEDITOR.dtd.$removeEmpty[i] = false;
    });

    $(".wysiwyg").ckeditor();

    $("section[data-pagetip]").each(function () {
        var $t = $(this);
        var cke = $t.find("article");
        cke.data("wysiwyg", cke.html());
        var editBtn = $t.find(".btn-info");
        var saveBtn = $t.find(".btn-success");
        saveBtn.hide();
        var cancelBtn = $t.find(".btn-warning");
        cancelBtn.hide();

        editBtn.click(function () {
            cke.ckeditor();
            cke.attr('contenteditable', true);
            cke.focus();
            editBtn.hide();
            saveBtn.show();
            cancelBtn.show();
        });

        cancelBtn.click(function () {
            cke.ckeditor().editor.destroy();
            cke.attr('contenteditable', false);
            cke.html(cke.data("wysiwyg"));
            editBtn.show();
            saveBtn.hide();
            cancelBtn.hide();
        });
        saveBtn.click(function () {
            abp.services.api.pageTip.insertOrUpdate({
                reference: $t.attr("data-pagetip"),
                content: cke.html()
            }).done(function () {
                cke.data("wysiwyg", cke.html());
                cke.ckeditor().editor.destroy();
                cke.attr('contenteditable', false);
                editBtn.show();
                saveBtn.hide();
                cancelBtn.hide();
                _notify2.default.success(resx.Common.PageTipSaved);
            }).fail(function () {
                _notify2.default.error(resx.Common.AjaxError);
            });
        });
    });
});


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/editor.js
// module id = 433
// module chunks = 0